const allowedTouringCountries = [
  "FR",
  "ES",
  "DE",
  "IT",
  "GB",
  "IE",
  "SE",
  "PT",
  "HU",
  "DK",
  "NL",
  "BE",
  "AT",
  "PL",
  "GR",
  "US",
  "CA",
  "MX",
];

export const allowedTouringArtist = (countryCode: string): boolean => {
  return allowedTouringCountries.includes(countryCode);
};
